import { render, staticRenderFns } from "./AppReviewScoreSectionList.vue?vue&type=template&id=2291aec0&scoped=true"
import script from "./AppReviewScoreSectionList.vue?vue&type=script&lang=js"
export * from "./AppReviewScoreSectionList.vue?vue&type=script&lang=js"
import style0 from "./AppReviewScoreSectionList.vue?vue&type=style&index=0&id=2291aec0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2291aec0",
  null
  
)

export default component.exports